import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { IGetGameCategoriesShort } from 'types';
import { useTranslation } from 'react-i18next';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import { getGameCategoriesShortInfo } from 'backend/games';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import style from './CategorySelect.module.scss';

const { Option } = Select;

const CategorySelect: React.FC = () => {
	const { setCategory, selectedCategory } = useContext<IGameAssignmentContext>(GameAssignmentContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetGameCategoriesShort, void>(
		getGameCategoriesShortInfo,
	);
	const { t } = useTranslation('listing');

	const value = !loading ? selectedCategory : undefined;

	return (
		<div className={style.container} data-test="CategorySelect">
			<Text translationNameSpace="listing" translationKey="categoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setCategory}
				value={value}
				disabled={loading}
				loading={loading}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				allowClear={true}
				removeIcon={false}
				listItemHeight={response?.data.gameCategories.length}
				placeholder={t('selectPlaceholder')}>
				{response?.data.gameCategories.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="listing"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{response.data.gameCategories.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								{el.name}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default CategorySelect;
